/* Livi – varyant seçimi, konuşma sekmeleri, sabit sepet */
(function () {
  function money(cents) {
    try { return new Intl.NumberFormat('tr-TR', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'TRY', maximumFractionDigits: 2, minimumFractionDigits: 0 }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2) + ' ₺'; }
  }
  function initForm(form) {
    var dataEl = form.querySelector('[data-livi-variants]');
    if (!dataEl || form.dataset.liviReady) return;
    form.dataset.liviReady = '1';
    var variants = JSON.parse(dataEl.textContent);
    var idInput = form.querySelector('input[name="id"]');
    var priceEl = form.querySelector('[data-livi-price]');
    var wasEl = form.querySelector('[data-livi-was]');
    var btn = form.querySelector('[data-livi-submit]');
    var btnLabel = btn ? btn.textContent : '';
    function update() {
      var chosen = [];
      form.querySelectorAll('[data-livi-option]').forEach(function (fs) {
        var c = fs.querySelector('input:checked');
        chosen.push(c ? c.value : null);
        var lab = fs.querySelector('[data-livi-optlabel]');
        if (lab && c) lab.textContent = c.value;
      });
      var v = variants.find(function (x) { return x.options.every(function (o, i) { return chosen[i] == null || o === chosen[i]; }); });
      if (!v) return;
      idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      if (wasEl) { if (v.compare_at_price && v.compare_at_price > v.price) { wasEl.textContent = money(v.compare_at_price); wasEl.hidden = false; } else { wasEl.hidden = true; } }
      if (btn) { btn.disabled = !v.available; btn.textContent = v.available ? btnLabel : 'Tükendi'; }
    }
    form.addEventListener('change', update);
    update();
  }
  function initTabs(root) {
    var tabs = root.querySelectorAll('[role="tab"]');
    function select(n) {
      tabs.forEach(function (t, j) {
        t.setAttribute('aria-selected', j === n ? 'true' : 'false');
        t.tabIndex = j === n ? 0 : -1;
        var p = root.querySelector('#' + t.getAttribute('aria-controls'));
        if (p) p.hidden = j !== n;
      });
    }
    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { select(i); });
      tab.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
          e.preventDefault();
          var n = (i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
          select(n); tabs[n].focus();
        }
      });
    });
  }
  function initSticky(bar) {
    var watch = document.querySelector('#MainContent button[name="add"]') || document.querySelector('#MainContent form[action*="/cart/add"]');
    if ('IntersectionObserver' in window && watch) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { bar.classList.toggle('is-on', !en.isIntersecting && en.boundingClientRect.top < 0); });
      }).observe(watch);
    } else { bar.classList.add('is-on'); }
    var b = bar.querySelector('[data-livi-sticky-add]');
    if (!b) return;
    b.addEventListener('click', function () {
      var main = document.querySelector('#MainContent form[action*="/cart/add"]:not([data-livi-form]) input[name="id"]');
      var id = main ? main.value : b.getAttribute('data-fallback-id');
      b.disabled = true;
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] }) })
        .then(function (r) { if (!r.ok) throw r; window.location.href = '/cart'; })
        .catch(function () { b.disabled = false; window.scrollTo({ top: 0, behavior: 'smooth' }); });
    });
  }
  function boot(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-livi-form]').forEach(initForm);
    scope.querySelectorAll('[data-livi-tabs]').forEach(initTabs);
    scope.querySelectorAll('[data-livi-sticky]').forEach(initSticky);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); }); else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
